import { cn } from "@/lib/cn";

export interface WordmarkProps {
  className?: string;
  /**
   * Set on a dark ground, where the light treatment would disappear. The
   * chrome is white now, so this is the exception rather than the rule.
   */
  onDark?: boolean;
  /** Drops the wording and shows the badge alone, for a tight space. */
  markOnly?: boolean;
  /** One line and a smaller badge, for the bar across the top of the frame. */
  compact?: boolean;
}

/**
 * The company mark for the app chrome.
 *
 * The badge is the company's own, taken from firstgulfexchange.com. It is a
 * detailed circular seal, so it is set small beside the name rather than
 * blown up: at any size where the Arabic in the ring is legible it would
 * dominate a sidebar that is mostly navigation.
 */
export function Wordmark({
  className,
  onDark = false,
  markOnly = false,
  compact = false,
}: WordmarkProps) {
  return (
    <div className={cn("flex select-none items-center gap-2.5 leading-none", className)}>
      <img
        src="/brand/first-gulf-logo.png"
        alt={markOnly ? "First Gulf Exchange" : ""}
        aria-hidden={markOnly ? undefined : true}
        width={150}
        height={108}
        className={cn("w-auto shrink-0", compact ? "h-7" : "h-9")}
      />
      {markOnly ? null : (
        <div className="min-w-0">
          <span
            className={cn(
              "u-display block truncate font-extrabold",
              compact ? "text-base" : "text-md",
              onDark ? "text-board-text" : "text-fg",
            )}
          >
            First Gulf Exchange
          </span>
          {compact ? null : (
            <span
              className={cn(
                "mt-1 block truncate text-xs font-medium",
                onDark ? "text-board-muted" : "text-fg-subtle",
              )}
            >
              Human Resources
            </span>
          )}
        </div>
      )}
    </div>
  );
}
